<template>
    <span>
        <!-- Menú lateral que aparece sólo cuando drawer == true, siendo ésto posible sólo en ventanas sm: -->
        <v-navigation-drawer app v-model="drawer" class="grey lighten-5" disable-resize-watcher>
            <v-list dense class="pt-0">
                <v-list-item class="gmp-blue" @click="onServicios">
                    <v-list-item-action>
                        <v-icon color="rgba(0, 44, 66)">mdi-toolbox</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Servicios</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="gmp-blue" @click="onEspecialidades">
                    <v-list-item-action>
                        <v-icon color="rgba(0, 44, 66)">mdi-hospital-box</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Especialidades</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="gmp-blue" @click="onLaboratorio">
                    <v-list-item-action>
                        <v-icon color="rgba(0, 44, 66)">mdi-needle</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Laboratorio</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="gmp-blue" @click="onFAQ">
                    <v-list-item-action>
                        <v-icon color="rgba(0, 44, 66)">mdi-frequently-asked-questions</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Preguntas Frecuentes</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="gmp-blue" @click="onSitiosDeInteres">
                    <v-list-item-action>
                        <v-icon color="rgba(0, 44, 66)">mdi-web</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Sitios de Interés</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="gmp-blue" @click="onContacto">
                    <v-list-item-action>
                        <v-icon color="rgba(0, 44, 66)">mdi-phone</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Contacto</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="gmp-blue" @click="onAvisoPrivacidad">
                    <v-list-item-action>
                        <v-icon color="rgba(0, 44, 66)">mdi-scale-balance</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Aviso de Privacidad</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

            </v-list>
        </v-navigation-drawer>
        <!-- Termina menú lateral para dispositivos con ventanas sm -->

        
        <v-app-bar height="70" flat fixed app color="rgb(0, 44, 66)" dark clipped-left>
            <v-app-bar-nav-icon class="hidden-md-and-up"  @click="drawer = !drawer"></v-app-bar-nav-icon>

            <v-toolbar-title class="hidden-sm-and-down">
                <router-link to="/">
                    <img :height="$vuetify.breakpoint.mdAndUp===true?'70':'50'" :src="navMainLogo" />
                </router-link>
            </v-toolbar-title>

            <v-toolbar-title class="hidden-md-and-up">
                <router-link to="/">
                    <img height="75" :src="navMainLogo" />
                </router-link>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn
                    text
                    class="text-none"
                    color="blue-grey lighten-4"
                    @click="onServicios"
                >Servicios
                </v-btn>
                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn text class="text-none" color="blue-grey lighten-4" v-on="on">Especialidades</v-btn>
                    </template>
                    <v-list dense color="grey lighten-5">
                        <v-list-item @click="onAudiologia">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-volume-high</v-icon>&nbsp; Audiología
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onCardiologiaPediatrica">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-heart-pulse</v-icon>&nbsp; Cardiología Pediátrica
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onCirugiaPediatrica">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-box-cutter</v-icon>&nbsp; Cirugía Pediátrica
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onDermatologiaPediatrica">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-human-handsdown</v-icon>&nbsp; Dermatología Pediátrica
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onEndocrinologiaPediatrica">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-diabetes</v-icon>&nbsp; Endocrinología Pediátrica
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onGastroenterologiaPediatrica">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-stomach</v-icon>&nbsp; Gastroenterología Pediátrica
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onGinecologiaPediatrica">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-gender-female</v-icon>&nbsp; Ginecología Pediátrica
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onMedicinaDeRehabilitacion">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-basketball</v-icon>&nbsp; Medicina de Rehabilitación
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onNeonatologia">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-baby-face-outline</v-icon>&nbsp; Neonatología
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onNeurologiaPediatrica">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-brain</v-icon>&nbsp; Neurología Peditátrica
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onNutricion">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-food-apple</v-icon>&nbsp; Nutrición
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onOdontologiaPediatrica">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-tooth-outline</v-icon>&nbsp; Odontología Peditátrica
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onOftalmologia">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-eye-outline</v-icon>&nbsp; Oftalmología
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onOrtopedia">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-bone</v-icon>&nbsp; Ortopedia
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onOtorrinolaringologia">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-ear-hearing</v-icon>&nbsp; Otorrinolaringología
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onPediatria">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-human-child</v-icon>&nbsp; Pediatría
                            </v-list-item-title>
                        </v-list-item>

                        <v-list-item @click="onPsicologia">
                            <v-list-item-title>
                                <v-icon color="rgb(0, 44, 66)">mdi-head-snowflake</v-icon>&nbsp; Psicología
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn
                    text
                    class="text-none"
                    color="blue-grey lighten-4"
                    @click="onLaboratorio"
                >Laboratorio</v-btn>
                <v-btn
                    text
                    class="text-none"
                    color="blue-grey lighten-4"
                    @click="onFAQ"
                >Preguntas Frecuentes</v-btn>
                <v-btn
                    text
                    class="text-none"
                    color="blue-grey lighten-4"
                    @click="onSitiosDeInteres"
                >Sitios de Interés</v-btn>
                <v-btn
                    text
                    class="text-none"
                    color="blue-grey lighten-4"
                    @click="onContacto"
                >Contacto</v-btn>
                <v-btn
                    text
                    class="text-none"
                    color="blue-grey lighten-4"
                    @click="onAvisoPrivacidad"
                    >Aviso de Privacidad
                </v-btn>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn large class="text-none" icon @click="onFacebook" v-on="on">
                            <img height="30" src="../assets/f_logo_RGB-Blue_58.png" />
                        </v-btn>
                    </template>
                    <span>Síguenos en Facebook</span>
                </v-tooltip>&nbsp;&nbsp;
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn large class="text-none" icon @click="onWhatsApp" v-on="on">
                            <img height="30" src="../assets/whatsapp.png" />
                        </v-btn>
                    </template>
                    <span>Contáctanos por Whatsapp</span>
                </v-tooltip>
            </v-toolbar-items>
        </v-app-bar>

        <v-overlay :value="overlay">
            <v-btn icon @click="overlay = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-overlay>
    </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'AppNavigation',
    data() {
        return {
            drawer: false,
            overlay: false,
            activeBtn: 1
        };
    },
    created() {
        console.log("vuetify.breakpoint = ", this.$vuetify.breakpoint);
    },
    methods: {
        onServicios() {
            //this.$router.push('/licoreria').catch(err => {});
        },
        onEspecialidades() {
            //this.$router.push('/cerveceria').catch(err => {});
        },
        onLaboratorio() {
            //this.$router.push('/restaurante').catch(err => {});
        },
        onFAQ() {
            //this.$router.push('/gourmet').catch(err => {});
        },
        onSitiosDeInteres() {
            
        },
        onContacto() {},

        onAvisoPrivacidad() {},

        onFacebook() {},

        onWhatsApp() {},

        onAudiologia(){},

        onCardiologiaPediatrica(){},

        onCirugiaPediatrica(){},

        onDermatologiaPediatrica(){},

        onEndocrinologiaPediatrica(){},

        onGastroenterologiaPediatrica(){},

        onGinecologiaPediatrica(){},

        onMedicinaDeRehabilitacion(){},

        onNeonatologia(){},

        onNeurologiaPediatrica(){},

        onNutricion(){},

        onOdontologiaPediatrica(){},

        onOftalmologia(){},

        onOrtopedia(){},

        onOtorrinolaringologia(){},

        onPediatria() {
            this.$router.push('/pediatria');
            this.drawer = false;
        },

        onPsicologia(){},


    },
    computed: {
        ...mapGetters(['navAppTitle', 'navMainLogo']),
        cartItems: {
            get() {
                return this.$store.getters.cartItems;
            },
            set(cartItems) {
                this.$store.dispatch('updateCartItems', cartItems);
            }
        }
    }
};
</script>

<style scoped>
h5 {
    /* color: 'teal darken-1'; */
    color: #00897b;
}
.usr-name {
    font-size: 14px;
    color: #00897b;
}
.gmp-blue {
    color: #002c42;
    /*BC1212 = 0, 44, 66 */
}
.catabocata-brown {
    color: #3e2723;
}

.mainMenu {
    font-size: 80px;
}

.cata_2 {
    font-family: bourbon;
    font-size: 1.2em;
    /* font-size: 18px; */
}

@font-face {
    font-family: bourbon;
    /*src: url(./sansumi-demibold.ttf);*/
    /* background: url('../assets/scott-warman-h4AGlo55tTA-unsplash.png');*/
    src: url('../css/BourbonW00Regular.ttf');
}

.imgHolderMainMenu {
    position: relative;
}
.imgHolderMainMenu span {
    position: absolute;
    right: 28px;
    top: -10px;
}

.imgHolderSideMenu {
    position: relative;
}
.imgHolderSideMenu span {
    position: absolute;
    right: 6px;
    top: -5px;
}
</style>
